import { render, staticRenderFns } from "./le-input-address-point.vue?vue&type=template&id=61cafc51&"
import script from "./le-input-address-point.vue?vue&type=script&lang=js&"
export * from "./le-input-address-point.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports